var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrash = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 28"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.578 25.356V9.281h17.395v16.075a1.891 1.891 0 0 1-1.891 1.894H3.47a1.893 1.893 0 0 1-1.892-1.894zM18.643 1.964c1.046 0 1.908.84 1.908 1.885v1.915a1.914 1.914 0 0 1-1.908 1.903H1.91A1.916 1.916 0 0 1 0 5.764V3.85c0-1.046.865-1.885 1.91-1.885h5.282A3.366 3.366 0 0 1 10.277 0c1.365 0 2.541.78 3.084 1.964h5.282z",
  fillRule: "nonzero"
})));
export default SvgTrash;